import type { ModuleRoute } from '../types';
import { DataProtectionPage } from './DataProtectionPage';

/** Pages of this area (data protection: find a person, export, erasure, legal holds, retention overview, request queue). Owned by Phase 4 task W28; only that task edits files in this folder (W32 wires it last). */
export const routes: ModuleRoute[] = [{ path: '/manage/data-protection', element: <DataProtectionPage />, permission: 'data_protection.view' }];
